import {
    Check, CircleNotch, Trash, X
} from '@phosphor-icons/react';
import { useTranslation } from '@client-app/i18n';
import dingtalkIcon from '@common/assets/icons/dingtalk.svg';
import metaAdsIcon from '@common/assets/icons/meta-ads.svg';
import clsx from 'clsx';

// 品牌图标 URL 映射表 - 参考设计稿实现
const BRAND_ICONS: Record<string, string> = {
    'Shopify': 'https://cdn.brandfetch.io/shopify.com/icon',
    'WooCommerce': 'https://cdn.brandfetch.io/woocommerce.com/icon',
    'BigCommerce': 'https://cdn.brandfetch.io/bigcommerce.com/icon',
    'Magento': 'https://cdn.brandfetch.io/magento.com/icon',
    'Wix': 'https://cdn.brandfetch.io/wix.com/icon',
    'Squarespace': 'https://cdn.brandfetch.io/squarespace.com/icon',
    'PrestaShop': 'https://cdn.brandfetch.io/prestashop.com/icon',
    'Salesforce Commerce': 'https://cdn.brandfetch.io/salesforce.com/icon',
    'Square': 'https://cdn.brandfetch.io/squareup.com/icon',
    'Toast': 'https://cdn.brandfetch.io/toasttab.com/icon',
    'Clover': 'https://cdn.brandfetch.io/clover.com/icon',
    'Lightspeed': 'https://cdn.brandfetch.io/lightspeedhq.com/icon',
    'Shopify POS': 'https://cdn.brandfetch.io/shopify.com/icon',
    'Vend': 'https://cdn.brandfetch.io/vendhq.com/icon',
    'Revel': 'https://cdn.brandfetch.io/revelsystems.com/icon',
    'TouchBistro': 'https://cdn.brandfetch.io/touchbistro.com/icon',
    'Meta Ads': metaAdsIcon,
    'Facebook Page': 'https://cdn.brandfetch.io/facebook.com/icon',
    'Instagram': 'https://cdn.brandfetch.io/instagram.com/icon',
    'Judge.me': 'https://cdn.brandfetch.io/judge.me/icon',
    'Google Search Console': 'https://cdn.brandfetch.io/search.google.com/icon',
    'Google Ads': '/imgs/Google_Ads.jpeg',
    'Semrush': 'https://cdn.brandfetch.io/semrush.com/icon',
    'Similarweb': 'https://cdn.brandfetch.io/similarweb.com/icon',
    'Ahrefs': 'https://cdn.brandfetch.io/ahrefs.com/icon',
    'Okendo': 'https://cdn.brandfetch.io/okendo.io/icon',
    'GoAffPro': 'https://cdn.brandfetch.io/goaffpro.com/icon',
    'UpPromote': 'https://cdn.brandfetch.io/uppromote.com/icon',
    'Loox': 'https://cdn.brandfetch.io/loox.io/icon',
    'TrustWILL': 'https://cdn.brandfetch.io/loloyal.com/icon',
    'NoxInfluencer': 'https://cdn.brandfetch.io/noxinfluencer.com/icon',
    'Facebook Ads': 'https://cdn.brandfetch.io/facebook.com/icon',
    'TikTok Ads': 'https://cdn.brandfetch.io/tiktok.com/icon',
    'Pinterest Ads': 'https://cdn.brandfetch.io/pinterest.com/icon',
    'LinkedIn Ads': 'https://cdn.brandfetch.io/linkedin.com/icon',
    'X Ads': 'https://cdn.brandfetch.io/x.com/icon',
    'YouTube': 'https://cdn.brandfetch.io/youtube.com/icon',
    'Reddit': 'https://cdn.brandfetch.io/reddit.com/icon',
    'Attribuly': 'https://cdn.brandfetch.io/attribuly.com/icon',
    'Snapchat Ads': 'https://cdn.brandfetch.io/snapchat.com/icon',
    'Klaviyo': 'https://cdn.brandfetch.io/klaviyo.com/icon',
    'Mailchimp': 'https://cdn.brandfetch.io/mailchimp.com/icon',
    'Attentive': 'https://cdn.brandfetch.io/attentive.com/icon',
    'Postscript': 'https://cdn.brandfetch.io/postscript.io/icon',
    'Omnisend': 'https://cdn.brandfetch.io/omnisend.com/icon',
    'Insider One': 'https://cdn.brandfetch.io/useinsider.com/icon',
    'Emarsys': 'https://cdn.brandfetch.io/emarsys.com/icon',
    'Sendlane': 'https://cdn.brandfetch.io/sendlane.com/icon',
    'ActiveCampaign': 'https://cdn.brandfetch.io/activecampaign.com/icon',
    'Constant Contact': 'https://cdn.brandfetch.io/constantcontact.com/icon',
    'Google Analytics': '/imgs/Google_Analytics.png',
    'Segment': 'https://cdn.brandfetch.io/segment.com/icon',
    'Mixpanel': 'https://cdn.brandfetch.io/mixpanel.com/icon',
    'Amplitude': 'https://cdn.brandfetch.io/amplitude.com/icon',
    'Heap': 'https://cdn.brandfetch.io/heap.io/icon',
    'Hotjar': 'https://cdn.brandfetch.io/hotjar.com/icon',
    'Looker': 'https://cdn.brandfetch.io/looker.com/icon',
    'Tableau': 'https://cdn.brandfetch.io/tableau.com/icon',
    'Stripe': 'https://cdn.brandfetch.io/stripe.com/icon',
    'PayPal': 'https://cdn.brandfetch.io/paypal.com/icon',
    'QuickBooks': 'https://cdn.brandfetch.io/quickbooks.intuit.com/icon',
    'Xero': 'https://cdn.brandfetch.io/xero.com/icon',
    'Square Payments': 'https://cdn.brandfetch.io/squareup.com/icon',
    'Braintree': 'https://cdn.brandfetch.io/braintreepayments.com/icon',
    'FreshBooks': 'https://cdn.brandfetch.io/freshbooks.com/icon',
    'Wave': 'https://cdn.brandfetch.io/waveapps.com/icon',
    'Zendesk': 'https://cdn.brandfetch.io/zendesk.com/icon',
    'Intercom': 'https://cdn.brandfetch.io/intercom.com/icon',
    'HubSpot': 'https://cdn.brandfetch.io/hubspot.com/icon',
    'Salesforce': 'https://cdn.brandfetch.io/salesforce.com/icon',
    'Gorgias': 'https://cdn.brandfetch.io/gorgias.com/icon',
    'Freshdesk': 'https://cdn.brandfetch.io/freshworks.com/icon',
    'Help Scout': 'https://cdn.brandfetch.io/helpscout.com/icon',
    'Pipedrive': 'https://cdn.brandfetch.io/pipedrive.com/icon',
    'ShipStation': 'https://cdn.brandfetch.io/shipstation.com/icon',
    'ShipBob': 'https://cdn.brandfetch.io/shipbob.com/icon',
    'Deliverr': 'https://cdn.brandfetch.io/deliverr.com/icon',
    'EasyShip': 'https://cdn.brandfetch.io/easyship.com/icon',
    'UPS': 'https://cdn.brandfetch.io/ups.com/icon',
    'FedEx': 'https://cdn.brandfetch.io/fedex.com/icon',
    'USPS': 'https://cdn.brandfetch.io/usps.com/icon',
    'DHL': 'https://cdn.brandfetch.io/dhl.com/icon',
    'Slack': 'https://cdn.brandfetch.io/slack.com/icon',
    'Feishu': 'https://cdn.brandfetch.io/feishu.cn/icon',
    'DingTalk': dingtalkIcon,
    'Figma': 'https://cdn.brandfetch.io/figma.com/icon',
    'AliExpress': 'https://cdn.brandfetch.io/aliexpress.com/icon',
    'Discord': 'https://cdn.brandfetch.io/discord.com/icon',
    'Trello': 'https://cdn.brandfetch.io/trello.com/icon',
    'Asana': 'https://cdn.brandfetch.io/asana.com/icon',
    'Notion': 'https://cdn.brandfetch.io/notion.so/icon',
    'ClickUp': 'https://cdn.brandfetch.io/clickup.com/icon',
};

export const getBrandIcon = (name: string) => {
    return BRAND_ICONS[name] || `https://cdn.brandfetch.io/${name.toLowerCase().replace(/\s+/g, '')}.com/icon`;
};

const BRAND_ICON_TREATMENTS: Record<string, { frame?: string; image?: string }> = {
    // Brand assets contain different amounts of internal whitespace. Keep the
    // perceived logo weight consistent across every Admin integration surface.
    'Wix': {
        image: 'scale-[1.6]',
    },
    'Google Ads': {
        image: 'scale-[1.3]',
    },
    'Google Analytics': {
        image: 'scale-[1.4]',
    },
    // The bundled Google G glyph fills almost its entire source canvas. Reduce
    // its optical weight anywhere these Google products reuse that asset.
    'Google Search Console': {
        image: 'scale-[0.82]',
    },
    'google-search-console': {
        image: 'scale-[0.82]',
    },
    'gsc': {
        image: 'scale-[0.82]',
    },
    'Google Merchant Center': {
        image: 'scale-[0.82]',
    },
    'google-merchant-center': {
        image: 'scale-[0.82]',
    },
    'Google Workspace': {
        image: 'scale-[0.82]',
    },
    'google-workspace': {
        image: 'scale-[0.82]',
    },
};

export const getBrandIconFrameClassName = (name: string) => {
    return BRAND_ICON_TREATMENTS[name]?.frame || 'bg-white shadow-sm ring-1 ring-gray-100';
};

export const getBrandIconImageClassName = (name: string, defaultClassName = 'h-5 w-5') => {
    return clsx(defaultClassName, 'origin-center object-contain', BRAND_ICON_TREATMENTS[name]?.image);
};

interface IntegrationCardProps {
    tool: string;
    supported: boolean;
    comingSoon?: boolean;
    isConnected: boolean;
    isSyncing: boolean;
    onConnect: () => void;
    onDisconnect?: () => void;
    onRegister?: () => void;
    onCancelPending?: () => void;
    isPending?: boolean;
    canConnect?: boolean;
    canDisconnect?: boolean;
}

export default function IntegrationCard({
    tool,
    supported,
    isConnected,
    isSyncing,
    onConnect,
    onDisconnect,
    onRegister,
    onCancelPending,
    isPending = false,
    canConnect = true,
    canDisconnect = true,
}: IntegrationCardProps) {
    const { t } = useTranslation();
    // comingSoon 优先级高于 supported
    const isAvailable = supported;
    const canClickConnect = canConnect && !isSyncing;
    const canClickDisconnect = canDisconnect && !isSyncing;

    return (
        <div
            className={clsx(
                "flex flex-col p-4 rounded-xl border transition-all duration-300 relative overflow-hidden",
                isConnected
                    ? "border-gray-200 bg-white shadow-sm cursor-default group"
                    : isAvailable
                        ? "border-gray-200 bg-white shadow-sm hover:shadow-md hover:-translate-y-0.5 hover:border-gray-300 cursor-pointer group"
                        : "border-gray-200 bg-white shadow-sm cursor-default"
            )}
        >
            {isPending && (
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onCancelPending?.();
                    }}
                    className="absolute top-2 right-2 p-1.5 text-text-sub/40 hover:text-text-main hover:bg-gray-100 rounded-lg transition-all"
                    title={t('common.cancel')}
                    aria-label={t('common.cancel')}
                >
                    <X size={16} weight="regular" />
                </button>
            )}

            <div className="flex items-center gap-3">
                <div
                    className={clsx(
                        "w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-all duration-300",
                        getBrandIconFrameClassName(tool)
                    )}
                >
                    <img
                        src={getBrandIcon(tool)}
                        alt={tool}
                        className={getBrandIconImageClassName(tool, 'h-5 w-5')}
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = 'https://cdn.brandfetch.io/google.com/icon';
                        }}
                    />
                </div>
                <div className="min-w-0 flex-1">
                    <h4 className="font-semibold text-base leading-tight text-text-main text-gray-900 truncate" title={tool}>{tool}</h4>
                </div>
            </div>

            <div className="mt-auto pt-4">
                {isPending ? (
                    <div className="space-y-2 animate-in slide-in-from-bottom-2 duration-300">
                        <div className="flex-1 flex flex-col items-center justify-center py-4 text-center animate-in fade-in zoom-in-95 duration-300">
                            <div className="w-10 h-10 bg-primary/5 rounded-full flex items-center justify-center mb-3">
                                <CircleNotch size={20} weight="regular" className="text-primary animate-spin" />
                            </div>
                            <p className="text-sm font-semibold text-text-main">{t('website.integrationsSettings.waitingForRegistration')}</p>
                            <p className="text-xs text-text-sub mt-1 max-w-[180px]">{t('website.integrationsSettings.returnAfterCreatingAccount')}</p>
                        </div>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onCancelPending?.();
                                if (!isSyncing && isAvailable && canClickConnect && !isConnected) {
                                    onConnect();
                                }
                            }}
                            className="w-full px-3 py-2 rounded-lg text-sm font-bold bg-[#1A162F] text-white hover:bg-primary/90 transition-all shadow-sm flex items-center justify-center gap-2"
                        >
                            {t('website.integrationsSettings.connectNow')}
                        </button>
                    </div>
                ) : (
                    <>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                if (isSyncing || !isAvailable) return;

                                if (isConnected && onDisconnect) {
                                    if (!canClickDisconnect) return;
                                    onDisconnect();
                                } else if (!isConnected) {
                                    if (!canClickConnect) return;
                                    onConnect();
                                }
                            }}
                            disabled={isSyncing || !isAvailable || (isConnected ? !canClickDisconnect : !canClickConnect)}
                            className={clsx(
                                "w-full px-3 py-2 rounded-lg text-sm font-semibold transition-all flex items-center justify-center shadow-sm group/btn",
                                isConnected
                                    ? canClickDisconnect
                                        ? "bg-green-100 border border-green-500 text-green-800 font-bold hover:bg-red-50 hover:border-red-500 hover:text-red-600"
                                        : "bg-green-100 border border-green-500 text-green-800 font-bold cursor-not-allowed opacity-75"
                                    : isAvailable
                                        ? canClickConnect
                                            ? "bg-white border border-[#1A162F] text-[#1A162F] hover:bg-[#1A162F] hover:text-white"
                                            : "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
                                        : "bg-gray-100 text-text-sub text-gray-400 border border-gray-200 cursor-not-allowed"
                            )}
                        >
                            {isSyncing ? (
                                <CircleNotch size={16} weight="regular" className="animate-spin" />
                            ) : isConnected ? (
                                <>
                                    <div className={clsx("flex items-center gap-1.5", canClickDisconnect && "group-hover/btn:hidden")}>
                                        <Check size={16} weight="regular" />
                                        <span>{t('website.integrationsSettings.connected')}</span>
                                    </div>
                                    {canClickDisconnect ? (
                                        <div className="hidden group-hover/btn:flex items-center gap-1.5">
                                            <Trash size={16} weight="regular" />
                                            <span>{t('website.integrationsSettings.disconnect')}</span>
                                        </div>
                                    ) : null}
                                </>
                            ) : isAvailable ? (
                                t('website.integrationsSettings.connect')
                            ) : (
                                t('website.integrationsSettings.soon')
                            )}
                        </button>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!isConnected && isAvailable) {
                                    onRegister?.();
                                }
                            }}
                            className={clsx(
                                "text-xs mt-3 flex items-center justify-center gap-1 w-full font-medium transition-colors",
                                (!isConnected && isAvailable) ? "text-[#667085] hover:text-primary cursor-pointer opacity-100" : "invisible pointer-events-none select-none"
                            )}
                            aria-hidden={!(!isConnected && isAvailable)}
                            tabIndex={(!isConnected && isAvailable) ? 0 : -1}
                        >
                            {t('website.integrationsSettings.dontHaveAccountSignUp')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
